import { render, staticRenderFns } from "./firmengruppesearch.vue?vue&type=template&id=f83243ea&scoped=true"
import script from "./firmengruppesearch.vue?vue&type=script&lang=js"
export * from "./firmengruppesearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83243ea",
  null
  
)

/* custom blocks */
import block0 from "./firmengruppesearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports